export const GetAuthAlternativo = () => {
   let emailAuth = localStorage.getItem('emailAuth')
   let tokenEmail = localStorage.getItem('tokenAuth')

   return {
      email: emailAuth,
      token: tokenEmail
   }
}
